var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVibeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo_Vibe_Azul",
    "data-name": "Logo Vibe Azul",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 147.667,
    height: 63.066,
    viewBox: "0 0 147.667 63.066",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_19062",
    "data-name": "Ret\\xE2ngulo 19062",
    width: 147.667,
    height: 63.066,
    fill: "#655eff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17375",
    "data-name": "Grupo 17375",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_28090",
    "data-name": "Caminho 28090",
    d: "M279.319,0q2.867.335,5.734.67c.635.074,1.27.141,2.016.223l-1.183,2.038c1.382-.5,2.615-1.06,3.908-1.383a16.985,16.985,0,0,1,12.943,1.777c4.415,2.528,6.63,7.7,5.839,13.08a15.664,15.664,0,0,1-2.993,7.374c-.132.173-.236.368-.392.614a21.256,21.256,0,0,1,9.059,6.723c4.97,6.44,6.272,13.507,3.119,21.1-2.961,7.127-9.933,10.744-17.548,9.429a23.954,23.954,0,0,1-14.375-7.791c-.1-.109-.092-.306-.136-.461l-.348.217c-.167,2.847-.333,5.694-.509,8.692l-10.033-.8c0-.335-.015-.621,0-.9q.862-14.894,1.731-29.788.854-14.5,1.729-28.992c.036-.6.049-1.209.073-1.814ZM308.9,44.695A10.392,10.392,0,0,0,302.82,35,22.083,22.083,0,0,0,288.8,33.024c-2.693.461-2.915.863-2.519,3.61.913,6.332,8.332,13.756,14.912,14.922,3.861.684,6.463-.964,7.373-4.712.195-.8.259-1.636.337-2.149M286.759,23.778c3.532-1.182,6.816-2.381,9.364-4.875a9.141,9.141,0,0,0,2.113-3.281c.887-2.414-.087-3.859-2.624-4.3a12.813,12.813,0,0,0-7.441.929c-.346.15-.789.575-.811.9-.24,3.464-.4,6.933-.6,10.633",
    transform: "translate(-211.894)",
    fill: "#655eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_28091",
    "data-name": "Caminho 28091",
    d: "M527.9,5.991q-.225,3.214-.45,6.427c-.044.63-.08,1.26-.12,1.906-2.327-.405-4.542-.869-6.78-1.163a27.337,27.337,0,0,0-10.833.326,8.208,8.208,0,0,0-2.37,1.048c-2.7,1.8-2.6,5.016.213,6.6a13.536,13.536,0,0,0,8.691,1.511c2.915-.4,5.806-.975,8.832-1.495-.137,3.176-.276,6.438-.411,9.582-3.189,1.174-6.313,2.212-9.346,3.47a31.6,31.6,0,0,0-8.874,5.431,11.5,11.5,0,0,0-4.041,6.021,5.61,5.61,0,0,0,3.023,6.663,16.06,16.06,0,0,0,7.453,1.756c3.824.079,7.653-.041,11.48-.074.442,0,.884,0,1.427,0-.189,3.386-.372,6.659-.561,10.044-1.364.063-2.672.121-3.98.184-6.123.294-12.21.2-18.062-1.945-5-1.837-8.9-4.87-10.463-10.205a16.47,16.47,0,0,1,1.4-12.632,27.306,27.306,0,0,1,8.481-9.762c.3-.216.606-.435.958-.688a24.782,24.782,0,0,1-2.548-1.095c-9.69-5.5-7.5-15.939-1.7-20.421,3.51-2.713,7.636-3.692,11.935-4.24,4.385-.56,8.69.29,13.028.582,1.209.081,2.413.233,3.619.352Z",
    transform: "translate(-379.946 -2.359)",
    fill: "#655eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_28092",
    "data-name": "Caminho 28092",
    d: "M213.693,0l7.1,4.19c.486.287.973.572,1.567.92l-5,8.384-8.791-4.976L213.466,0Z",
    transform: "translate(-161.055)",
    fill: "#655eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_28093",
    "data-name": "Caminho 28093",
    d: "M42.773,4.378c-.368.594-.547.91-.751,1.209a16.232,16.232,0,0,0-3.075,10.691q.736,8.636,1.777,17.245c.639,5.334,1.411,10.655.992,16.045-.306,3.948-1.322,7.677-3.952,10.784a12.462,12.462,0,0,1-9.229,4.506c-4.084.187-8.183.045-12.275.088-.775.008-.814-.478-.948-.992q-4.2-16.117-8.407-32.233Q3.577,18.949.254,6.175C.171,5.855.113,5.529,0,5.008H2.333c2.35,0,4.7.034,7.05-.018.853-.019,1.227.2,1.459,1.094q6.183,23.971,12.449,47.921c.066.254.15.5.232.777a31.363,31.363,0,0,0,4.177-.034c2.225-.3,3.6-1.772,3.729-4.337a63.06,63.06,0,0,0-.119-9.385C30.618,34,29.609,27,28.887,19.969a27.963,27.963,0,0,1,.764-11.024c.153-.506.313-1.012.511-1.5,1.163-2.886,1.611-3.14,4.674-3.077,2.561.053,5.124.011,7.938.011",
    transform: "translate(0 -3.366)",
    fill: "#655eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_28094",
    "data-name": "Caminho 28094",
    d: "M216.263,72.7c-.853,15.329-1.691,30.385-2.538,45.608l-10.154-.381q1.267-22.777,2.515-45.227Z",
    transform: "translate(-157.193 -56.139)",
    fill: "#655eff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVibeLogo);
export default __webpack_public_path__ + "static/media/vibe-logo.4e7823d5484499a8d0962d4088d2ed7c.svg";
export { ForwardRef as ReactComponent };